import { useFormikContext } from 'formik';
import Image from 'next/image';
import React from 'react';

import { Select, SelectContent, SelectFieldTrigger, SelectItem, SelectValue } from '@/design-system/components/ui';

import useGetChainInfo from '../../../../../../common/hooks/useGetChainInfo';
import { NETWORKS } from '../../../../../../common/types/network';
import { LiquidityV3TriggerFormValues } from '../../../../domain';

interface NetworkSelector {
  chainIds: number[] | undefined;
}

export const NetworkSelector = ({ chainIds }: NetworkSelector) => {
  const { errors, setFieldValue, handleBlur, values } = useFormikContext<LiquidityV3TriggerFormValues>();

  const { getChainIconUrl } = useGetChainInfo();

  const networks = NETWORKS.filter((network) => chainIds && chainIds.includes(network.chainId));

  return (
    <Select
      name="chainId"
      value={values.chainId ? String(values.chainId) : undefined}
      onValueChange={(val) => {
        // Select values are always strings, and `handleChange` keeps them that way. The forms compare
        // this against the numeric `chain_id` the API returns, so a string here silently finds no
        // protocol and disables the pool lookup.
        setFieldValue('chainId', Number(val));
      }}
    >
      <SelectFieldTrigger
        label="Network"
        error={!!errors.chainId}
        errorMessage={errors.chainId ? String(errors.chainId) : undefined}
        onBlur={handleBlur}
      >
        <SelectValue placeholder="Select network" />
      </SelectFieldTrigger>
      <SelectContent>
        {networks.map((network) => {
          const chainIconUrl =
            getChainIconUrl(network.chainId) || `/assets/svg/${network.name.split(' ').join('-').toLowerCase()}.svg`;

          return (
            <SelectItem key={network.chainId} value={String(network.chainId)}>
              <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
                {chainIconUrl ? <Image src={chainIconUrl} width={20} height={20} alt={network.name} /> : <div></div>}
                <span className="tw:capitalize">{network.name}</span>
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
